import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

interface PromotionalBanner {
  _id: string;
  title: string;
  subtitle?: string;
  isActive: boolean;
  backgroundColor: string;
  textColor: string;
  linkUrl?: string;
  linkText?: string;
  priority: number;
}

const PromotionalBanner: React.FC = () => {
  const [banners, setBanners] = useState<PromotionalBanner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await api.get('/api/promotional-banners/active');
        setBanners(response.data);
      } catch (error) {
        console.error('Error fetching promotional banners:', error);
        // No fallback banner - only show if admin creates one
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading || banners.length === 0) {
    return null;
  }

  return (
    <div className="space-y-1">
      {banners.map((banner) => (
        <div
          key={banner._id}
          className="py-2 px-4 text-center text-sm md:text-base font-medium leading-none"
          style={{
            backgroundColor: banner.backgroundColor,
            color: banner.textColor
          }}
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 flex-wrap">
            <span className="mr-2 leading-none align-middle">🔥</span>
            <span className="leading-none align-middle">{banner.title}</span>
            {banner.subtitle && (
              <span className="ml-2 text-xs opacity-90 leading-none align-middle">{banner.subtitle}</span>
            )}
            {banner.linkUrl && banner.linkText && (
              <Link
                to={banner.linkUrl}
                className="ml-3 underline underline-offset-4 decoration-1 transition-all duration-200 inline-flex items-center align-middle leading-none"
                style={{ color: banner.textColor }}
              >
                {banner.linkText}
              </Link>
            )}
            <span className="ml-2 leading-none align-middle">🔥</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PromotionalBanner;
